import React, { useState } from 'react';
import { Form, Spin } from "antd";
import {
  LoginContainer,
  LoginCard,
  LoginImg,
  FormContainer,
  StyledInput,
  StyledButton,
  LogoContainer,
  InputWrapper,
  InputIcon,
  PasswordToggle,
  IllustrationSection,
  FormSection,
  PageLoadingContainer,
  PageLoadingContent,
  PageLoadingTitle,
  PageLoadingSubtitle,
  CustomSpinContainer
} from './Style';
import { ArrowRightOutlined, EyeFilled, LockFilled, UserOutlined, LoadingOutlined } from '@ant-design/icons';
import { FiEyeOff } from 'react-icons/fi';
import Login_Img from "../../../../src/Assets/Images/oslo_loginlogo.png";

const SignInForm = ({ handleSignIn, loading, pageLoading = false }) => {
  const [form] = Form.useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  const onFinish = (values) => {
    handleSignIn(values);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const antIcon = <LoadingOutlined spin />;

  if (pageLoading) {
    return (
      <PageLoadingContainer>
        <PageLoadingContent>
          <Spin indicator={antIcon} size="large" />
          <PageLoadingTitle>Loading OSLO...</PageLoadingTitle>
          <PageLoadingSubtitle>Please wait while we prepare your experience</PageLoadingSubtitle>
        </PageLoadingContent>
      </PageLoadingContainer>
    );
  }

  return (
    <LoginContainer>
      <LoginCard>
        <IllustrationSection style={{ flex: '1.2' }}>
          <LoginImg>
            <LogoContainer>
              <div className="logo-icon" style={{ 
                transform: 'scale(1.1)',
                transition: 'transform 0.3s ease'
              }}>
                <img 
                  src={Login_Img} 
                  alt="OSLO Logo" 
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    borderRadius: '50%'
                  }}
                />
              </div>
              
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
              }}>
                <p style={{
                  fontSize: '14px',
                  color: 'rgba(255, 255, 255, 0.8)',
                  textAlign: 'center',
                  margin: '0',
                  fontWeight: '300'
                }}>
                Enter your personal details and start your journey with us.
                </p>
              </div>
            </LogoContainer>
          </LoginImg>
        </IllustrationSection>

        <FormSection style={{ flex: '0.8' }}>
          <FormContainer>
            <CustomSpinContainer 
              spinning={loading} 
              indicator={antIcon}
              tip="Signing you in..."
            >
              <div className="form-header" style={{ marginBottom: '30px' }}>
                <h1 style={{ fontSize: '24px', marginBottom: '8px' }}>Welcome Back</h1>
                <p style={{ fontSize: '15px', color: '#666' }}>Sign in to access your dashboard</p>
              </div>

              <Form
                form={form}
                onFinish={onFinish}
                layout="vertical"
                className="login-form"
              >
                <Form.Item
                  label="User Name"
                  name="username"
                  rules={[
                    { required: true, message: 'Please input your username!' }
                  ]}
                >
                  <InputWrapper>
                    <InputIcon>
                      <UserOutlined />
                    </InputIcon>
                    <StyledInput
                      placeholder="Enter your username"
                      name="username"
                      type="text"
                      onChange={handleInputChange}
                      disabled={loading}
                    />
                  </InputWrapper>
                </Form.Item>

                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    { required: true, message: 'Please input your password!' }
                  ]}
                >
                  <InputWrapper>
                    <InputIcon>
                      <LockFilled />
                    </InputIcon>
                    <StyledInput
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Enter your password"
                      name="password"
                      onChange={handleInputChange}
                      disabled={loading}
                    />
                    <PasswordToggle
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      disabled={loading}
                    >
                      {showPassword ? <FiEyeOff size={18} /> : <EyeFilled size={18} />}
                    </PasswordToggle>
                  </InputWrapper>
                </Form.Item>

                <StyledButton
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  className="login-button"
                  style={{ 
                    marginTop: '20px',
                    height: '50px',
                    fontSize: '16px',
                    fontWeight: '600'
                  }}
                >
                  {loading ? 'Signing In...' : 'Login'}
                  {!loading && <ArrowRightOutlined />}
                </StyledButton>
              </Form>

              <div style={{
                textAlign: 'center',
                marginTop: '24px',
                fontSize: '12px',
                color: '#737373'
              }}>
                By signing in, you agree to our Terms of Service and Privacy Policy
              </div>
              
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                marginTop: '20px',
                color: '#999',
                fontSize: '12px'
              }}>
                <div style={{
                  width: '20px',
                  height: '20px',
                  background: 'linear-gradient(135deg, #dc2626, #991b1b)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <span style={{ color: 'white', fontSize: '10px', fontWeight: 'bold' }}>O</span>
                </div>
                <span>Powered by OSLO</span>
              </div>
            </CustomSpinContainer>
          </FormContainer>
        </FormSection>
      </LoginCard>
    </LoginContainer>
  );
};

export default SignInForm;